import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";

import { signupReducer } from "../features/auth/signup/signupSlice";
import { loginDataReducer } from "../features/auth/login/loginSlice";
import { forgotPasswordLinkReducer } from "../features/auth/forget-password/forgotPasswordSlice";
import { resetPasswordLinkReducer } from "../features/auth/reset-password/resetPasswordSlice";
import { uploadDocumentReducer } from "../features/user-document/uploadDocumentSlice";
import { logoutDataReducer } from "../features/auth/logout/logoutSlice";
import { updateDocumentReducer } from "../features/user-document/updateDocumentSlice";
import { documentListingReducer } from "../features/user-document/documentListingSlice";
import { deleteDocumentReducer } from "../features/user-document/deleteDocumentSlice";
import { getSingleDocumentReducer } from "../features/user-document/getDocumentSlice";
import { archiveDocumentReducer } from "../features/user-document/archiveDocumentSlice";
import { syncSliceReducer } from "../features/user-document/syncSlice";
import { unSyncSliceReducer } from "../features/user-document/unsyncSlice";
import { favouriteDocumentReducer } from "../features/user-document/favouriteDocument";
import { getUserListReducer } from "../features/userManagement/getUserListSlice";
import { getUserRoleListReducer } from "../features/userManagement/getUserRolesSlice";
import { activateDeactivateUserReducer } from "../features/userManagement/activateDeactivateUserSlice";
import { deleteUserReducer } from "../features/userManagement/deleteUserSlice";
import { getProjectListReducer } from "../features/projectManagement/getProjectListSlice";
import { getUserReducer } from "../features/userManagement/getParticularUserSlice";
import { documentLableAddReducer } from "../features/user-document/document-label";
import { labelListingReducer } from "../features/user-document/label-listing";
import { getSingleLabelReducer } from "../features/user-document/getSingleLabelSlice";
import { updateLabelReducer } from "../features/user-document/updateLabelSlice";
import { deleteLabelReducer } from "../features/user-document/deleteLabelSlice";
import { editUserReducer } from "../features/userManagement/editUserSlice";
import { addUserReducer } from "../features/userManagement/addUserSlice";
import { addProjectReducer } from "../features/projectManagement/addProjectSlice";
import { deleteProjectReducer } from "../features/projectManagement/deleteProjectSlice";
import { getProfileDataReducer } from "../features/profile-management/getProfileDataSlice";
import { getParticularProjectReducer } from "../features/projectManagement/getParticularProject";
import { editProjectReducer } from "../features/projectManagement/editProjectSlice";
import { changePasswordReducer } from "../features/profile-management/changePasswordSlice";
import { labelDocumentReducer } from "../features/user-document/labelDocumentSaveSlice";
import { removeTagsReducer } from "../features/user-document/removeTagsSlice";
import { getUserVerifyReducer } from "../features/userManagement/userVerifySlice";
import { verifyEmailReducer } from "../features/auth/verify-email/verifyEmailSlice";
import { activateAccountReducer } from "../features/auth/activate-account/activateAccountSlice";
import { getSiteReducer } from "../features/chatbot/getSiteDataSlice";
import { manageProfileReducer } from "../features/profile-management/manageProfileSlice";
import { roleListingReducer } from "../features/role-management/roleListingSlice";
import { getConversationsReducer } from "../features/chatbot/getConversationsSlice";
import { getParticularConversationReducer } from "../features/chatbot/getParticularConversationSlice";
import { getLabelReducer } from "../features/chatbot/labelListSlice";
import { fetchCrawlledUrlReducer } from "../features/user-document/fetchCrawlUrls";
import { crawlDocumentReducer } from "../features/user-document/crawlDocumentsSlice";
import { getProjectPermissionReducer } from "../features/project-permission/getProjectPermissionSlice";
import { deleteRoleReducer } from "../features/role-management/deleteRoleSlice";
import { roleModuleListingReducer } from "../features/role-management/moduleListSlice";
import { addRoleReducer } from "../features/role-management/addRoleSlice";
import { getSingleRoleListingReducer } from "../features/role-management/getSingleRoleSlice";
import { updateRoleReducer } from "../features/role-management/updateRoleSlice";
import { activeRoleReducer } from "../features/role-management/activeRoleSlice";
import { getSwitchProjectListSliceReducer } from "../features/projectManagement/switchProjectSlice";
import { inviteOnlyReducer } from "../features/chatbot/inviteOnlySlice";
import { getDocumentLabelListOfInviteOnlyUsersReducer } from "../features/chatbot/getDocumentLabelListOfInviteOnlyUsersSlice";
import { getSummaryPromptReducer } from "../features/summaryPrompt/getSummaryPromptSlice";
import { updateSummaryTextReducer } from "../features/summaryPrompt/updateSummaryTextSlice";
import { createSummaryPromptReducer } from "../features/summaryPrompt/createSummaryPromptSlice";
import { showSummaryPromptReducer } from "../features/summaryPrompt/showSummaryPromptSlice";
import { updateSummaryPromptReducer } from "../features/summaryPrompt/updateSummaryPromptSlice";
import { deleteSummaryPromptReducer } from "../features/summaryPrompt/deleteSummaryPromptSlice";
import { activateSummaryPromptReducer } from "../features/summaryPrompt/activateSummaryPromptSlice";
import { regenerateSummaryPromptReducer } from "../features/summaryPrompt/regenerateSummaryPromptSlice";
import { getPersonaReducer } from "../features/persona/getPersonaSlice";
import { createPersonaReducer } from "../features/persona/createPersonaSlice";
import { showPersonaReducer } from "../features/persona/showPersonaSlice";
import { updatePersonaReducer } from "../features/persona/updatePersonaSlice";
import { deletePersonaReducer } from "../features/persona/deletePersonaSlice";
import { bulkDeletePersonaReducer } from "../features/persona/bulkDeletePersonaSlice";
import { activatePersonaReducer } from "../features/persona/activatePersonaSlice";
import { sendShareDocumentSettingsReducer } from "../features/chatbot/sendShareDocumentSettings";
import { getToneReducer } from "../features/tones/getToneSlice";
import { createToneReducer } from "../features/tones/createToneSlice";
import { showToneReducer } from "../features/tones/showToneSlice";
import { updateToneReducer } from "../features/tones/updateToneSlice";
import { deleteToneReducer } from "../features/tones/deleteToneSlice";

export const store = configureStore({
  reducer: combineReducers({
    signupReducer: signupReducer,
    loginReducer: loginDataReducer,
    logoutDataRedicer: logoutDataReducer,
    forgotPasswordLinkReducer: forgotPasswordLinkReducer,
    resetPasswordLinkReducer: resetPasswordLinkReducer,
    verifyEmailReducer: verifyEmailReducer,
    activateAccountReducer: activateAccountReducer,

    uploadDocumentReducer: uploadDocumentReducer,
    updateDocumentReducer: updateDocumentReducer,
    documentListing: documentListingReducer,
    deleteDocument: deleteDocumentReducer,
    getSingleDocument: getSingleDocumentReducer,
    archiveDocumentReducer: archiveDocumentReducer,
    favouriteDocumentReducer: favouriteDocumentReducer,
    syncSlice: syncSliceReducer,
    unSyncSlice: unSyncSliceReducer,
    addLabelSlice: documentLableAddReducer,
    labelListingSlice: labelListingReducer,
    singleLabelSlice: getSingleLabelReducer,
    updateLabelSlice: updateLabelReducer,
    deleteSlice: deleteLabelReducer,
    addDocLabelSlice: labelDocumentReducer,
    removeTagsSlice: removeTagsReducer,
    fetchCrawlledUrlReducer: fetchCrawlledUrlReducer,
    crawlDocumentReducer: crawlDocumentReducer,

    getUserListReducer: getUserListReducer,
    getUserRoleListReducer: getUserRoleListReducer,
    activateDeactivateUserReducer: activateDeactivateUserReducer,
    editUserReducer: editUserReducer,
    addUserReducer: addUserReducer,
    deleteUserReducer: deleteUserReducer,
    getUserReducer: getUserReducer,

    getProjectListReducer: getProjectListReducer,
    addProjectReducer: addProjectReducer,
    editProjectReducer: editProjectReducer,
    getParticularProjectReducer: getParticularProjectReducer,
    deleteProjectReducer: deleteProjectReducer,
    getSwitchProjectListSliceReducer: getSwitchProjectListSliceReducer,

    getProjectPermissionReducer: getProjectPermissionReducer,

    getProfileDataReducer: getProfileDataReducer,
    changePasswordReducer: changePasswordReducer,
    manageProfileReducer: manageProfileReducer,

    getSummaryPromptReducer: getSummaryPromptReducer,
    createSummaryPromptReducer: createSummaryPromptReducer,
    showSummaryPromptReducer: showSummaryPromptReducer,
    updateSummaryPromptReducer: updateSummaryPromptReducer,
    deleteSummaryPromptReducer: deleteSummaryPromptReducer,
    activateSummaryPromptReducer: activateSummaryPromptReducer,
    updateSummaryTextReducer: updateSummaryTextReducer,
    regenerateSummaryPromptReducer: regenerateSummaryPromptReducer,

    getPersonaReducer: getPersonaReducer,
    createPersonaReducer: createPersonaReducer,
    showPersonaReducer: showPersonaReducer,
    updatePersonaReducer: updatePersonaReducer,
    deletePersonaReducer: deletePersonaReducer,
    bulkDeletePersonaReducer: bulkDeletePersonaReducer,
    activatePersonaReducer: activatePersonaReducer,

    getToneReducer: getToneReducer,
    createToneReducer: createToneReducer,
    showToneReducer: showToneReducer,
    updateToneReducer: updateToneReducer,
    deleteToneReducer: deleteToneReducer,

    inviteOnlyReducer: inviteOnlyReducer,

    getRoleListing: roleListingReducer,
    deleteRoleReducer: deleteRoleReducer,
    getRoleModuleListing: roleModuleListingReducer,
    addRoleReducer: addRoleReducer,
    getSingleRoleListingReducer: getSingleRoleListingReducer,
    updateRoleReducer: updateRoleReducer,
    activeRoleReducer: activeRoleReducer,
    userVerifySlice: getUserVerifyReducer,

    getSiteData: getSiteReducer,
    getDocumentLabelListOfInviteOnlyUsers:
      getDocumentLabelListOfInviteOnlyUsersReducer,
    getConversationsData: getConversationsReducer,
    getParticularConversationData: getParticularConversationReducer,
    getLabelReducer: getLabelReducer,

    sendShareDocumentSettingsReducer: sendShareDocumentSettingsReducer,
  }),
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
  ],
});

export default store;
